export default function isReportPageOpened() {
  const pathname = window.location.pathname
  const queryParams = new URLSearchParams(window.location.search)
  return pathname.endsWith('/report') && queryParams.has('static', 'true')
}
